import type { Prototype } from "../prototype-types";

export const jaiMankooPrototypes: Prototype[] = [
  {
    id: "jm-promoted-listings-advertiser-profiles",
    name: "Promoted Listings Advertiser Profiles",
    path: "/jm/promoted-listings-advertiser-profiles",
    description:
      "Ads Manager dashboard with an advertiser-profile switcher sourced from advertiserProfile entities: floor budget, median, high budget, under-utilized, churned, poor ROAS, new &amp; returning, budget-capped.",
    owner: "Jai Mankoo",
    createdAt: "2026-07-06",
    lastUpdated: "2026-07-06",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.faire.com/fastly/3ad182d534ddd436eae874afdf73108979b773d4bd26bf02d86a4d8cc39fca3c.png",
    creationTool: "claude-code",
  },
  {
    id: "jm-store-type-legend-select-all",
    name: "Store Type Legend Select All",
    path: "/jm/store-type-legend-select-all",
    description:
      "Eight visual treatments of a Select all and Deselect all pair on the store type chart legend, from links to toggles to card-header buttons.",
    owner: "Jai Mankoo",
    createdAt: "2026-08-24",
    lastUpdated: "2026-08-24",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    project: "Store Type Boosting",
    thumbnail: "/images/thumbnails/jm-store-type-legend-select-all.png",
    creationTool: "cursor",
  },
  {
    id: "jm-ads-credit-surfaces",
    name: "Ads Credit Surfaces",
    path: "/jm/ads-credit-surfaces",
    description:
      "Fourteen ads-credit treatments across the Setup budget step, Setup review step, churned advertiser settings page, and confirm-settings modal, from the PRD options to a proposed helper-slot pattern, with the onboarding hero as a reference for the copy that ships today.",
    owner: "Jai Mankoo",
    createdAt: "2026-08-26",
    lastUpdated: "2026-08-26",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    project: "Ads Credit",
    thumbnail: "/images/thumbnails/jm-ads-credit-surfaces.png",
    creationTool: "cursor",
  },
  {
    id: "jm-retailer-insights-pos",
    name: "Retailer Insights POS",
    path: "/jm/retailer-insights-pos",
    description:
      "Retailer Insights as a single narrative page: an Endcap recap, filterable spend by category, ranked brands, Faire's read on the retailer as a buyer, and an analytics directory. Best sellers is the one card Faire's order data cannot fill, so the POS ask lives there rather than as a banner.",
    owner: "Jai Mankoo",
    createdAt: "2026-09-14",
    lastUpdated: "2026-09-15",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "/images/thumbnails/jm-retailer-insights-pos.png",
    creationTool: "cursor",
  },
  {
    id: "jm-product-boosting-v-2-m-1",
    name: "Product Boosting v2 - M1",
    path: "/jm/product-boosting-v-2-m-1",
    description:
      "A focused product boosting concept combining specific products and new-product boosting in Advanced settings, with a browse-by-tag/collection product picker.",
    owner: "Jai Mankoo",
    createdAt: "2026-09-24",
    lastUpdated: "2026-09-24",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "/images/thumbnails/jm-product-boosting-v-2-m-1.png",
    creationTool: "cursor",
  },
  {
    id: "jm-ads-signup-payment-simplification",
    name: "Ads Signup Payment Simplification",
    path: "/jm/ads-signup-payment-simplification",
    description:
      "Three-arm XP for the Promoted Listings setup wizard: Control, Auto-select payment, and Skip payment, across five payment-method states.",
    owner: "Jai Mankoo",
    createdAt: "2026-10-06",
    lastUpdated: "2026-10-06",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    project: "Simplify payment confirmation",
    thumbnail: "/images/thumbnails/jm-ads-signup-payment-simplification.png",
    creationTool: "cursor",
  },
  {
    id: "jm-promoted-listings-quarter-start",
    name: "Promoted Listings Quarter Start",
    path: "/jm/promoted-listings-quarter-start",
    description:
      "Three quarter-start empty states for the Promoted Listings home card, compared against today's card: a last-quarter recap, a come-back-soon message, and a blurred card with copy on top.",
    project: "Promoted Listings Home Card",
    owner: "Jai Mankoo",
    createdAt: "2026-10-06",
    lastUpdated: "2026-10-06",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    creationTool: "cursor",
    thumbnail: "/images/thumbnails/jm-promoted-listings-quarter-start.png",
  },
  {
    id: "jm-goal-based-ads-setup",
    name: "Goal-based Ads Setup",
    path: "/jm/goal-based-ads-setup",
    description:
      "Goal-first Promoted Listings setup (goals, details, budget, review) and a goal-based Ads Manager dashboard, with every wireframe alternative as a toolbar variant.",
    project: "Goal-based Ads Manager",
    owner: "Jai Mankoo",
    createdAt: "2026-10-08",
    lastUpdated: "2026-10-08",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    creationTool: "cursor",
    thumbnail: "/images/thumbnails/jm-goal-based-ads-setup.png",
  },
  {
    id: "jm-products-page-ads-post-click",
    name: "Products Page Ads Post-Click",
    path: "/jm/products-page-ads-post-click",
    description:
      "Post-click flows for the Products page Adopt and Reactivate banners: gated boosting step in setup, post-start redirect to Advanced settings, and Advanced vs General landing for restart.",
    project: "Ads Banner updates",
    owner: "Jai Mankoo",
    createdAt: "2026-10-19",
    lastUpdated: "2026-10-19",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    creationTool: "cursor",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/7cf097c4b96d4f8a7d14b9a7d56d7452d05bddf4d1ce2f9bf691f9a5113e050b.png",
  },
  {
    id: "jm-ads-manager-brand-refinement",
    name: "Ads Manager Brand Refinement",
    path: "/jm/ads-manager-brand-refinement",
    description:
      "Current Ads Manager (dashboard tabs, advertising settings, settings history, setup wizard, invoices) replicated from production and driven by advertiser profiles, with a toggle to the brand refinement design system.",
    project: "Brand Refinement",
    owner: "Jai Mankoo",
    createdAt: "2026-10-19",
    lastUpdated: "2026-10-19",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    figmaLink:
      "https://www.figma.com/design/WYuZ5tcftNHaP4flK0owVG/Brand-Refinement-%7C-Brand-Surfaces?node-id=222-131504",
    creationTool: "cursor",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/94482f033d57a10a911964296548e171c484be1c06677810b95f5093254fbed1.png",
  },
  {
    id: "jm-ads-manager-2-brand-refinement",
    name: "Ads Manager 2.0 Brand Refinement",
    path: "/jm/ads-manager-2-brand-refinement",
    description:
      "Fork of Irene Limb's latest Ads Manager 2.0 prototype (/il/ads-manager-2-overview) with a toggle that applies the brand refinement design system.",
    project: "Brand Refinement",
    owner: "Jai Mankoo",
    createdAt: "2026-10-19",
    lastUpdated: "2026-10-19",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    figmaLink:
      "https://www.figma.com/design/WYuZ5tcftNHaP4flK0owVG/Brand-Refinement-%7C-Brand-Surfaces?node-id=222-131504",
    creationTool: "cursor",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/bd06f342ea48ad008b68e1f80c725e26f53484442b927634bef5faa3b5e474de.png",
  },
];
